/**
 * Event Filters
 * Create the list used it seems exclusively in the events section
 */
import React from 'react'

// eslint-disable-next-line import/prefer-default-export
import { Hash } from '../..'

export type EventFilters = {
  include?: string[]
  name: string
  type: string
}

export type EventFiltersProps = {
  filter?: string[]
  handleClick?: (type: string, include?: string[]) => void
  items: EventFilters[]
  sort?: string
  filteredBytype?: string
  filterOverlay?: boolean
  title: string
}

export const EventListingsFilters = ({
  filter,
  handleClick = () => {},
  items,
  sort,
  title,
  filteredBytype,
  filterOverlay
}: EventFiltersProps) => {
  const renderItems = () =>
    items.map(({ include, name, type }) => {
      let className
      if (filterOverlay) {
        if (filteredBytype === type) className = 'active'
      } else if ((sort || (filter && filter[0]) || filteredBytype) === type)
        className = 'active'

      return (
        <li className={className} key={Hash(['eventTab', name].join('#'))}>
          <button
            onClick={() => handleClick(type, include)}
            style={{
              background: 'none',
              border: 'none',
              margin: 0,
              padding: 0,
              textTransform: 'uppercase'
            }}
            type="button"
          >
            {name}
          </button>
        </li>
      )
    })

  return (
    <div className="event__tabs--group">
      <div className="event__tabs-title heading--6">{title}</div>
      <ul className="event__tabs">{renderItems()}</ul>
    </div>
  )
}
